import LogoCompact from './LogoCompact'

export default LogoCompact
